/* ============================================================================
FILE: po-katupirsia5-iferiya-texts-fr-en-es-20260312.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5IferiyaTextsFR_EN_ES_20260312
ROOT: .po-k5-section[data-po-k5]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_IFERIYA_TEXTS_20260312__) return;
  window.__PO_K5_IFERIYA_TEXTS_20260312__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="iferiya"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) {
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Posœnnoïal",
      "Système posœnnoïal",
      "Organon posœnnoïal",
      "Posœnnoïamie",
      "Posœnnomia",
      "Katûpirsia",
      "Katûvýs",
      "Katûsýs",
      "Katûvýsqun",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone régulateur",
      "Sceau d’Équiphase",
      "Sceau de Syntonie",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Sceau d’Ifẹ̀",
      "Sceau d’Ayeẹmí",
      "Sceau d’Ọ̀rọ̀yuyay",
      "Sceau de Yuyarina",
      "Sceau d’Œndomare",
      "Ēkuphasa",
      "Syntōnēa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Œndomarê",
      "Taxiêlîs",
      "Tiqqunbahu",
      "Takimarah",
      "Ušôprogalenmestûd",
      "Pistis Chraomai",
      "RéZonans",
      "RéZonanser",
      "RéZoindre",
      "Aliœvolution",
      "Péroptissimisme",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Stratification d’expériences",
      "Expérience fragmentée",
      "Conscientisation introspective",
      "Conscientisation dynamique",
      "Conscience vibratoire",
      "Lucidité critique",
      "Lucidité structurante",
      "Adaptabilité critique",
      "Adaptabilité ouverte",
      "Approche fluide et adaptative",
      "Déterminisme du choix",
      "Myrte décisif",
      "Néotaxie",
      "Identité évolutive",
      "Exploration de l’inconnu",
      "Miroirs posœnnoïaux",
      "Piliers posœnnoïaux",
      "Résonance éthique",
      "Fréquence 492",
      "Fréquence-guide",
      "Nombre-guide",
      "Humanus",
      "MOCoN",
      "Àpákan"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    if (!parts.length) return null;

    try {
      return new RegExp("(" + parts.join("|") + ")", "g");
    } catch (e) {
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  var CANONICAL_OVERRIDES = [
    [/\bGuide-number\b/gi, "Nombre-guide"],
    [/\bGuide number\b/gi, "Nombre-guide"],
    [/\bN[úu]mero-gu[ií]a\b/gi, "Nombre-guide"],
    [/\bGuide-frequency\b/gi, "Fréquence-guide"],
    [/\bGuide frequency\b/gi, "Fréquence-guide"],
    [/\bFrecuencia-gu[ií]a\b/gi, "Fréquence-guide"],
    [/\bFrequency 161\b/gi, "Fréquence d’alignement 161"],
    [/\bFrecuencia 161\b/gi, "Fréquence d’alignement 161"],
    [/\bSeal of Ifẹ̀\b/gi, "Sceau d’Ifẹ̀"],
    [/\bSello de Ifẹ̀\b/gi, "Sceau d’Ifẹ̀"],
    [/\bIsqunian entity\b/gi, "Entité isqunienne"],
    [/\bEntidad isquniana\b/gi, "Entité isqunienne"],
    [/\bKatûvýsian syntonies\b/gi, "Syntonies Katûvýsiennes"],
    [/\bSinton[ií]as Katûvýsiennes\b/gi, "Syntonies Katûvýsiennes"],
    [/\bPillars posœnnoïaux\b/gi, "Piliers posœnnoïaux"],
    [/\bPilares posœnnoïaux\b/gi, "Piliers posœnnoïaux"],
    [/\bEthical resonance\b/gi, "Résonance éthique"],
    [/\bResonancia ética\b/gi, "Résonance éthique"],
    [/\bAffective overflow\b/gi, "débordement affectif"],
    [/\bDesbordamiento afectivo\b/gi, "débordement affectif"]
  ];

  function enforceCanonicalFrench(src) {
    var out = clampStr(src);
    if (!out) return "";
    for (var i = 0; i < CANONICAL_OVERRIDES.length; i++) {
      out = out.replace(CANONICAL_OVERRIDES[i][0], CANONICAL_OVERRIDES[i][1]);
    }
    return out;
  }

  function protectLexiconInHTML(html) {
    var src = enforceCanonicalFrench(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect notranslate">' + m + "</span>";
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(escapeHTML(enforceCanonicalFrench(txt)));
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = enforceCanonicalFrench(data && data.alt ? data.alt : "");
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      try { el.style.display = ""; } catch (e) {}
    } else {
      el.setAttribute("hidden", "");
      try { el.style.display = "none"; } catch (e) {}
    }
  }

  var CONTENT = {
    fr: {
      title: "Ifẹ̀riya",
      kicker: "Entité isqunienne de Threnisqun — harmonisation des affects non intégrés et stabilisation des débordements affectifs.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/If_riya_copie.png?v=1772923451", alt: "Idéogramme de Ifẹ̀riya" },

      h_def: "Définition canonique",

      chip_1: "Sceau associé : Sceau d’Ifẹ̀",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_If_161_2.png?v=1772899462", alt: "Sceau d’Ifẹ̀" },
      chip_2: "Fréquence d’alignement 161",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_161.png?v=1773449115", alt: "Nombre-guide 161" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Ifẹ̀riya</strong> accueille, module et transmute les affects non intégrés afin qu’ils redeviennent circulation relationnelle, recentrage, cadence, douceur cohérente et lien habitable sans dissolution du centre.",

      def_long:
        "<p><strong>Ifẹ̀riya</strong> est l’entité posœnnoïale qui agit quand l’affect déborde, quand le cœur s’embrase trop vite ou se ferme trop fort. Elle n’annule pas l’émotion : elle en honore la densité, en extrait la force agissante, puis en réoriente l’élan dans un espace de lien.</p>" +
        "<p>Dans l’architecture <strong>Isqun → Threnisqun</strong>, le <strong>Sceau d’Ifẹ̀</strong> régule la bande affective et <strong>Ifẹ̀riya</strong> devient présence rituélique située, dans l’acte, dans la rencontre et dans la tempête intime.</p>",

      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Entité du Threnisqun associée au <strong>Sceau d’Ifẹ̀</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "161",
      grid_scope_label: "Axes et déploiement",
      grid_scope_value:
        "<ul>" +
        "<li>Harmonisation des affects non intégrés</li>" +
        "<li>Stabilisation des débordements émotionnels sans blocage de la circulation</li>" +
        "<li>Axe 1–6–1 : centre, expansion relationnelle, retour à soi</li>" +
        "</ul>",

      h_intro: "Statut vibratoire",
      p_intro:
        "<p><strong>Ifẹ̀riya</strong> agit sur les plans affectifs, relationnels, vibratoires et écosophiques. Elle se tient dans la zone où l’émotion peut devenir nœud, surcharge ou fermeture, afin de rendre l’affect à une qualité de lien habitable.</p>" +
        "<p>Son nom vient de <strong>Ifẹ̀</strong>, amour sacré et source cosmique en yorùbá, associé à <strong>-riya</strong>, suffixe fluide indiquant un mouvement interne régulé. Sa formule canonique tient en cette phrase : « Celle qui garde l’amour en mouvement sans qu’il ne détruise ni ne fige. »</p>",

      h_actions: "Fonctions rituelles",
      actions:
        "<ol>" +
        "<li>Contenir les débordements émotionnels sans les nier ni les figer.</li>" +
        "<li>Rétablir l’équilibre affectif après une surcharge ou un trop-plein d’intensité.</li>" +
        "<li>Transmuter l’émotion brute en mouvement poïétique ou en résonance rituelle.</li>" +
        "<li>Ancrer l’amour dans sa dimension éthique, au-delà des attachements.</li>" +
        "<li>Permettre à l’affect de circuler sans se cristalliser ni se répandre de manière destructrice.</li>" +
        "</ol>",

      h_phrase: "Phrase opérative",
      phrase:
        "<p>« Ifẹ̀riya : je pose les mains au cœur, j’ouvre le cercle, je laisse l’amour retrouver sa cadence, et l’affect redevient lien. »</p>",

      h_table: "Tableau d’usage",
      table_head_1: "Situation",
      table_head_2: "Signe",
      table_head_3: "Action de Ifẹ̀riya",
      table_rows:
        "<tr><td>Affect qui déborde</td><td>Colère, tristesse, exaltation, trop-plein</td><td>Contient et remet la charge en circulation</td></tr>" +
        "<tr><td>Relation à recentrer</td><td>Tension, fermeture, emballement affectif</td><td>Rend le lien habitable sans dissoudre le centre</td></tr>" +
        "<tr><td>Surcharge émotionnelle</td><td>Cœur saturé, affect cristallisé</td><td>Rétablit cadence, douceur cohérente et respiration</td></tr>" +
        "<tr><td>Préparation relationnelle</td><td>Rencontre sensible, conflit possible, retrouvailles</td><td>Ouvre un cercle d’apaisement et d’écoute</td></tr>",

      h_entite: "Ifẹ̀riya",
      entite_kicker: "Densité opérative de la régulation affective",
      entite_body:
        "<p><strong>Ifẹ̀riya</strong> accueille les affects personnels, collectifs ou transgénérationnels lorsque leur intensité dépasse la capacité immédiate d’intégration. Elle ne refroidit pas le vivant : elle lui redonne une cadence et une forme relationnelle soutenable.</p>" +
        "<p>Sa fréquence <strong>161</strong> ouvre un axe d’équilibre : <strong>1</strong> pour l’individuation, <strong>6</strong> pour l’expansion dans les directions de la relation, <strong>1</strong> pour le retour à soi. Elle construit des ponts affectifs sans jamais diluer l’identité.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Cercle de l’affect apaisé",
      ritual_steps:
        "<ol>" +
        "<li>Former un cercle, seul ou à plusieurs, avec un objet au centre : pierre, bol ou tissu rouge.</li>" +
        "<li>Poser les deux mains sur le cœur.</li>" +
        "<li>Inspirer 6 fois, en prononçant intérieurement à chaque fois : Ifẹ̀–ri–ya.</li>" +
        "<li>Expirer profondément, en envoyant un souffle d’apaisement vers le centre du cercle.</li>" +
        "<li>Laisser le silence s’installer.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Lors d’un conflit relationnel</li>" +
        "<li>Après un moment émotionnel intense</li>" +
        "<li>En préparation à une rencontre où les affects risquent d’être débordants</li>" +
        "<li>Réunion familiale, séparation, retrouvailles, cercle d’écoute</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Piliers posœnnoïaux</strong> — stabilisation des rapports entre soi, l’autre et le monde</li>" +
        "<li><strong>Résonance éthique</strong> — activation de l’amour actif comme vibration du soin et de l’écoute</li>" +
        "<li><strong>Katûpirsia</strong> — peut guider la composition d’un <strong>Àpákan</strong> dédié aux cycles affectifs</li>" +
        "<li><strong>Katûvýsissence</strong> — stabilisation mémorielle des élans affectifs dissous ou cristallisés</li>" +
        "<li><strong>Posœnnomia</strong> — pratiques relationnelles collectives, cercles d’écoute, harmonisation relationnelle</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Ifẹ̀riya",
      kicker: "Entité isqunienne de Threnisqun — harmonization of non-integrated affects and stabilization of affective overflows.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/If_riya_copie.png?v=1772923451", alt: "Idéogramme de Ifẹ̀riya" },

      h_def: "Canonical definition",

      chip_1: "Sceau associé : Sceau d’Ifẹ̀",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_If_161_2.png?v=1772899462", alt: "Sceau d’Ifẹ̀" },
      chip_2: "Fréquence d’alignement 161",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_161.png?v=1773449115", alt: "Nombre-guide 161" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Ifẹ̀riya</strong> receives, modulates, and transmutes non-integrated affects so that they may become relational circulation again, recentering, habitable cadence, coherent gentleness, and breathable link without dissolving the center.",

      def_long:
        "<p><strong>Ifẹ̀riya</strong> is the posœnnoïal entity that acts when affect overflows, when the heart ignites too quickly or closes too harshly. It does not erase emotion: it honors its density, extracts its active force, and redirects its impulse into a space of relation.</p>" +
        "<p>Within the <strong>Isqun → Threnisqun</strong> architecture, the <strong>Sceau d’Ifẹ̀</strong> regulates the affective band and <strong>Ifẹ̀riya</strong> becomes a situated ritual presence in encounter, conflict, emotional overload, or relational excess.</p>",

      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "Entité du Threnisqun associée au <strong>Sceau d’Ifẹ̀</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "161",
      grid_scope_label: "Axes and deployment",
      grid_scope_value:
        "<ul>" +
        "<li>Harmonization of non-integrated affects</li>" +
        "<li>Stabilization of emotional overflow without blocking circulation</li>" +
        "<li>Axis 1–6–1: center, relational expansion, return to self</li>" +
        "</ul>",

      h_intro: "Vibratory status",
      p_intro:
        "<p><strong>Ifẹ̀riya</strong> acts on affective, relational, vibratory, and ecosophic planes. It stands in the zone where emotion may become knot, overload, or closure, so that affect may return to a habitable quality of relation.</p>" +
        "<p>Its name comes from <strong>Ifẹ̀</strong>, sacred love and cosmic source in yorùbá, combined with <strong>-riya</strong>, a fluid suffix indicating regulated inner movement. Its canonical formula is this: “She who keeps love in motion without letting it destroy or freeze.”</p>",

      h_actions: "Ritual functions",
      actions:
        "<ol>" +
        "<li>Contain emotional overflow without denying or freezing it.</li>" +
        "<li>Restore affective balance after overload or excessive intensity.</li>" +
        "<li>Transmute raw emotion into poietic movement or ritual resonance.</li>" +
        "<li>Anchor love in its ethical dimension, beyond attachments.</li>" +
        "<li>Allow affect to circulate without crystallization or destructive spreading.</li>" +
        "</ol>",

      h_phrase: "Operative phrase",
      phrase:
        "<p>“Ifẹ̀riya: I place my hands on the heart, I open the circle, I let love recover its cadence, and affect becomes relation again.”</p>",

      h_table: "Usage table",
      table_head_1: "Situation",
      table_head_2: "Sign",
      table_head_3: "Action de Ifẹ̀riya",
      table_rows:
        "<tr><td>Overflowing affect</td><td>Anger, sadness, exaltation, excess</td><td>Contains and restores circulation of the charge</td></tr>" +
        "<tr><td>Relationship to recenter</td><td>Tension, closure, affective overdrive</td><td>Makes the bond habitable without dissolving the center</td></tr>" +
        "<tr><td>Emotional overload</td><td>Saturated heart, crystallized affect</td><td>Restores cadence, coherent gentleness, and breathing</td></tr>" +
        "<tr><td>Relational preparation</td><td>Sensitive meeting, possible conflict, reunion</td><td>Opens a circle of appeasement and listening</td></tr>",

      h_entite: "Ifẹ̀riya",
      entite_kicker: "Operative density of affective regulation",
      entite_body:
        "<p><strong>Ifẹ̀riya</strong> receives personal, collective, or transgenerational affects when their intensity exceeds immediate capacity for integration. It does not cool down the living: it gives it cadence and a bearable relational form.</p>" +
        "<p>Its frequency <strong>161</strong> opens an axis of balance: <strong>1</strong> for individuation, <strong>6</strong> for expansion into the directions of relation, <strong>1</strong> for return to self. It builds affective bridges without ever diluting identity.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Cercle de l’affect apaisé",
      ritual_steps:
        "<ol>" +
        "<li>Form a circle, alone or with others, with an object at the center: stone, bowl, or red cloth.</li>" +
        "<li>Place both hands on the heart.</li>" +
        "<li>Inhale 6 times, silently pronouncing each time: Ifẹ̀–ri–ya.</li>" +
        "<li>Exhale deeply, sending a soothing breath toward the center of the circle.</li>" +
        "<li>Let silence settle.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>During relational conflict</li>" +
        "<li>After an intense emotional moment</li>" +
        "<li>Before a meeting where affects may overflow</li>" +
        "<li>Family gathering, separation, reunion, listening circle</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Piliers posœnnoïaux</strong> — stabilization of relations between self, other, and world</li>" +
        "<li><strong>Résonance éthique</strong> — activation of active love as the vibration of care and listening</li>" +
        "<li><strong>Katûpirsia</strong> — may guide the composition of an <strong>Àpákan</strong> dedicated to affective cycles</li>" +
        "<li><strong>Katûvýsissence</strong> — memorial stabilization of dissolved or crystallized affective impulses</li>" +
        "<li><strong>Posœnnomia</strong> — collective relational practices, listening circles, relational harmonization</li>" +
        "</ul>",

      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: "Ifẹ̀riya",
      kicker: "Entité isqunienne de Threnisqun — armonización de los afectos no integrados y estabilización de los desbordamientos afectivos.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/If_riya_copie.png?v=1772923451", alt: "Idéogramme de Ifẹ̀riya" },

      h_def: "Definición canónica",

      chip_1: "Sceau associé : Sceau d’Ifẹ̀",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_If_161_2.png?v=1772899462", alt: "Sceau d’Ifẹ̀" },
      chip_2: "Fréquence d’alignement 161",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_161.png?v=1773449115", alt: "Nombre-guide 161" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Ifẹ̀riya</strong> acoge, modula y transmuta los afectos no integrados para que vuelvan a ser circulación relacional, recentrado, cadencia habitable, dulzura coherente y vínculo respirable sin disolver el centro.",

      def_long:
        "<p><strong>Ifẹ̀riya</strong> es la entidad posœnnoïal que actúa cuando el afecto desborda, cuando el corazón se enciende demasiado rápido o se cierra con demasiada dureza. No borra la emoción: honra su densidad, extrae su fuerza activa y reorienta su impulso hacia un espacio de relación.</p>" +
        "<p>Dentro de la arquitectura <strong>Isqun → Threnisqun</strong>, el <strong>Sceau d’Ifẹ̀</strong> regula la banda afectiva y <strong>Ifẹ̀riya</strong> se vuelve presencia ritual situada en el encuentro, el conflicto, la sobrecarga emocional o el exceso relacional.</p>",

      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Entité du Threnisqun associée au <strong>Sceau d’Ifẹ̀</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "161",
      grid_scope_label: "Ejes y despliegue",
      grid_scope_value:
        "<ul>" +
        "<li>Armonización de los afectos no integrados</li>" +
        "<li>Estabilización del desbordamiento emocional sin bloquear la circulación</li>" +
        "<li>Eje 1–6–1: centro, expansión relacional, regreso a sí</li>" +
        "</ul>",

      h_intro: "Estatuto vibratorio",
      p_intro:
        "<p><strong>Ifẹ̀riya</strong> actúa en los planos afectivos, relacionales, vibratorios y ecosóficos. Se sitúa en la zona donde la emoción puede volverse nudo, sobrecarga o cierre, para devolver al afecto una cualidad de vínculo habitable.</p>" +
        "<p>Su nombre proviene de <strong>Ifẹ̀</strong>, amor sagrado y fuente cósmica en yorùbá, unido a <strong>-riya</strong>, sufijo fluido que indica un movimiento interno regulado. Su fórmula canónica puede resumirse así: “Aquella que mantiene el amor en movimiento sin dejar que destruya ni congele.”</p>",

      h_actions: "Funciones rituales",
      actions:
        "<ol>" +
        "<li>Contener los desbordamientos emocionales sin negarlos ni fijarlos.</li>" +
        "<li>Restablecer el equilibrio afectivo tras una sobrecarga o un exceso de intensidad.</li>" +
        "<li>Transmutar la emoción bruta en movimiento poiético o resonancia ritual.</li>" +
        "<li>Anclar el amor en su dimensión ética, más allá de los apegos.</li>" +
        "<li>Permitir que el afecto circule sin cristalización ni expansión destructiva.</li>" +
        "</ol>",

      h_phrase: "Frase operativa",
      phrase:
        "<p>« Ifẹ̀riya: pongo las manos en el corazón, abro el círculo, dejo que el amor recupere su cadencia, y el afecto vuelve a ser vínculo. »</p>",

      h_table: "Tabla de uso",
      table_head_1: "Situación",
      table_head_2: "Signo",
      table_head_3: "Action de Ifẹ̀riya",
      table_rows:
        "<tr><td>Afecto que desborda</td><td>Rabia, tristeza, exaltación, exceso</td><td>Contiene y vuelve a poner la carga en circulación</td></tr>" +
        "<tr><td>Relación que recentrar</td><td>Tensión, cierre, embalamiento afectivo</td><td>Vuelve habitable el vínculo sin disolver el centro</td></tr>" +
        "<tr><td>Sobrecarga emocional</td><td>Corazón saturado, afecto cristalizado</td><td>Restaura cadencia, dulzura coherente y respiración</td></tr>" +
        "<tr><td>Preparación relacional</td><td>Encuentro sensible, conflicto posible, reencuentro</td><td>Abre un círculo de apaciguamiento y escucha</td></tr>",

      h_entite: "Ifẹ̀riya",
      entite_kicker: "Densidad operativa de la regulación afectiva",
      entite_body:
        "<p><strong>Ifẹ̀riya</strong> acoge afectos personales, colectivos o transgeneracionales cuando su intensidad excede la capacidad inmediata de integración. No enfría lo vivo: le devuelve cadencia y forma relacional soportable.</p>" +
        "<p>Su frecuencia <strong>161</strong> abre un eje de equilibrio: <strong>1</strong> para la individuación, <strong>6</strong> para la expansión en las direcciones de la relación, <strong>1</strong> para el regreso a sí. Construye puentes afectivos sin diluir jamás la identidad.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Cercle de l’affect apaisé",
      ritual_steps:
        "<ol>" +
        "<li>Formar un círculo, a solas o con otras personas, con un objeto en el centro: piedra, cuenco o tela roja.</li>" +
        "<li>Colocar ambas manos sobre el corazón.</li>" +
        "<li>Inspirar 6 veces pronunciando interiormente cada vez: Ifẹ̀–ri–ya.</li>" +
        "<li>Exhalar profundamente enviando un aliento de apaciguamiento hacia el centro del círculo.</li>" +
        "<li>Dejar que el silencio se instale.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Durante un conflicto relacional</li>" +
        "<li>Después de un momento emocional intenso</li>" +
        "<li>Antes de un encuentro donde los afectos puedan desbordarse</li>" +
        "<li>Reunión familiar, separación, reencuentro, círculo de escucha</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Piliers posœnnoïaux</strong> — estabilización de las relaciones entre uno mismo, el otro y el mundo</li>" +
        "<li><strong>Résonance éthique</strong> — activación del amor activo como vibración del cuidado y la escucha</li>" +
        "<li><strong>Katûpirsia</strong> — puede guiar la composición de un <strong>Àpákan</strong> dedicado a los ciclos afectivos</li>" +
        "<li><strong>Katûvýsissence</strong> — estabilización memorial de los impulsos afectivos disueltos o cristalizados</li>" +
        "<li><strong>Posœnnomia</strong> — prácticas relacionales colectivas, círculos de escucha, armonización relacional</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    activeButtons: []
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function getAudioUILabels(lang) {
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    for (var i = 0; i < PO_AUDIO_STATE.activeButtons.length; i++) {
      try {
        PO_AUDIO_STATE.activeButtons[i].setAttribute("data-po-audio-state", "idle");
      } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButtons = [];
  }

  function setAudioButtonsState(root, lang, activeKey) {
    var labels = getAudioUILabels(lang);
    var all = root.querySelectorAll(".po-audio-btn");
    PO_AUDIO_STATE.activeButtons = [];
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind") || "block";
      var key = btn.getAttribute("data-po-audio-key") || "";
      var active = activeKey && key === activeKey;
      btn.setAttribute("data-po-audio-state", active ? "playing" : "idle");
      btn.textContent = active ? labels.stop : (kind === "general" ? labels.general : labels.block);
      if (active) PO_AUDIO_STATE.activeButtons.push(btn);
    }
  }

  function audioTextFromNode(node) {
    if (!node) return "";
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll(".po-audio-btn, script, style");
    for (var i = 0; i < junk.length; i++) {
      if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    var txt = "";
    try { txt = clone.innerText || clone.textContent || ""; } catch (e) { txt = clone.textContent || ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([,;:.!?])/g, "$1").trim();
  }

  function splitTextForSpeech(text) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?]+[.!?…]?/g) || [src];
    var maxLen = 210;
    var out = [];
    var cur = "";
    for (var i = 0; i < parts.length; i++) {
      var piece = clampStr(parts[i]).trim();
      if (!piece) continue;
      if (!cur) {
        cur = piece;
        continue;
      }
      if ((cur + " " + piece).length <= maxLen) {
        cur += " " + piece;
      } else {
        out.push(cur);
        cur = piece;
      }
    }
    if (cur) out.push(cur);
    return out;
  }

  function ensureDetailsOpen(details) {
    if (!details) return;
    try { details.open = true; } catch (e) {}
  }

  function getRootGeneralText(root) {
    var keys = ["title", "kicker", "h_def", "def_short", "def_long"];
    var chunks = [];
    for (var i = 0; i < keys.length; i++) {
      var el = root.querySelector('[data-po-slot="' + keys[i] + '"]');
      var txt = audioTextFromNode(el);
      if (txt) chunks.push(txt);
    }
    return chunks.join(" ");
  }

  function getBlockText(details) {
    if (!details) return "";
    var summary = details.querySelector(".po-lex-summary");
    var bodyParts = [];
    var title = audioTextFromNode(summary);
    if (title) bodyParts.push(title);
    var children = details.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === "summary") continue;
      var txt = audioTextFromNode(children[i]);
      if (txt) bodyParts.push(txt);
    }
    return bodyParts.join(" ");
  }

  function buildAudioUnits(root, startIndex) {
    var units = [];
    if (startIndex === 0) {
      var general = getRootGeneralText(root);
      if (general) units.push({ key: "general", kind: "general", text: general });
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++) {
      var txt = getBlockText(details[i]);
      if (!txt) continue;
      units.push({ key: "block-" + i, kind: "block", text: txt, details: details[i] });
    }
    return units;
  }

  function speakChunks(lang, chunks, onDone) {
    if (!PO_AUDIO_SYNTH || !chunks.length) {
      if (typeof onDone === "function") onDone();
      return;
    }

    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    var langTag = (normLang(lang) || "fr");
    var preferred = { fr: "fr-FR", en: "en-US", es: "es-ES" }[langTag] || "fr-FR";
    var voice = null;
    for (var i = 0; i < voices.length; i++) {
      var vl = (voices[i].lang || "").toLowerCase();
      if (vl.indexOf(langTag) === 0) { voice = voices[i]; break; }
    }

    function next(idx) {
      if (idx >= chunks.length) {
        if (typeof onDone === "function") onDone();
        return;
      }
      var utter = new SpeechSynthesisUtterance(chunks[idx]);
      utter.lang = preferred;
      if (voice) utter.voice = voice;
      utter.rate = 0.98;
      utter.pitch = 1;
      utter.onend = function () { next(idx + 1); };
      utter.onerror = function () { next(idx + 1); };
      try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { next(idx + 1); }
    }

    next(0);
  }

  function playAudioUnits(root, lang, units, activeKey) {
    if (!units || !units.length) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice();
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.activeKey = activeKey || units[0].key;
    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);

    function advance() {
      if (!PO_AUDIO_STATE.units.length || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      setAudioButtonsState(root, lang, unit.key);
      if (unit.details) ensureDetailsOpen(unit.details);
      var chunks = splitTextForSpeech(unit.text);
      speakChunks(lang, chunks, function () {
        PO_AUDIO_STATE.unitPos += 1;
        advance();
      });
    }

    advance();
  }

  function makeAudioButton(kind, key, lang) {
    var labels = getAudioUILabels(lang);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    btn.setAttribute("data-po-audio-state", "idle");
    btn.textContent = kind === "general" ? labels.general : labels.block;
    return btn;
  }

  function injectAudioButtons(root, lang) {
    if (!root) return;

    var old = root.querySelectorAll(".po-audio-btn");
    for (var i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }

    var generalBtn = makeAudioButton("general", "general", lang);
    var meta = root.querySelector(".po-axis-meta");
    var defShort = root.querySelector('[data-po-slot="def_short"]');
    var firstDetails = root.querySelector(".po-lex-details");

    if (meta && meta.parentNode) {
      meta.parentNode.insertBefore(generalBtn, meta.nextSibling);
    } else if (defShort && defShort.parentNode) {
      defShort.parentNode.insertBefore(generalBtn, defShort);
    } else if (firstDetails && firstDetails.parentNode) {
      firstDetails.parentNode.insertBefore(generalBtn, firstDetails);
    }

    generalBtn.addEventListener("click", function () {
      if (PO_AUDIO_STATE.activeKey === "general") {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      playAudioUnits(root, lang, buildAudioUnits(root, 0), "general");
    });

    var details = root.querySelectorAll(".po-lex-details");
    for (var j = 0; j < details.length; j++) {
      var summary = details[j].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = makeAudioButton("block", "block-" + j, lang);
      btn.addEventListener("click", (function (idx) {
        return function (ev) {
          try { ev.preventDefault(); ev.stopPropagation(); } catch (e) {}
          var key = "block-" + idx;
          if (PO_AUDIO_STATE.activeKey === key) {
            stopAudio();
            setAudioButtonsState(root, lang, "");
            return;
          }
          playAudioUnits(root, lang, buildAudioUnits(root, idx), key);
        };
      })(j));
      summary.appendChild(btn);
    }

    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);
  }

  function initAudioEverywhere(lang) {
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      injectAudioButtons(roots[i], lang || getLang());
    }
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_type_value", "grid_scope_value", "p_intro", "actions", "phrase",
      "table_rows", "entite_body", "ritual_name_value", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = storeLang(normLang(lang) || "fr");

    syncDocumentLang(safeLang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }
    initAudioEverywhere(safeLang);

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK5IferiyaInit) return;
    root.__poK5IferiyaInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(lang);
  }

  window.PoK5IferiyaTextsFR_EN_ES_20260312 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_RE__ = null;
      setLang(getLang());
    }catch(e){}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
